// extracted by mini-css-extract-plugin
export default {"productDescription":"Nda-z","featuredDescription":"Oda-z","description":"Pda-z","more":"Qda-z","descriptionSku":"Rda-z"};